<template>
  <div class="container">
    <h4 v-if="!loggedIn" class="alert alert-danger">
      You are not authorized to access TerraTrac. Please contact your IT administrator if you
      believe you should have access to TerraTrac.
    </h4>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'NotAuthorized',
  computed: {
    ...mapState({
      user: state => state.User.user,
    }),
    loggedIn() {
      return this.user.name;
    },
  },
};
</script>
